import { useEffect } from 'react'
import { useGlobalContext } from '../../components/GlobalContext/GlobalContext'
import { useAppSelector } from '../../redux/store'
import { serviceConfig, useGetServiceConfigQuery } from '../../modules/ServiceRuns/redux/cloudAppAPI'
import { AppStateProvider } from '../state/AppProvider'
import Chat from './Chat'

const ChatStandalone = () => {
  const { setChatNSRSettings, setLensCubeOptions } = useGlobalContext()
  const { data } = useAppSelector((state) => serviceConfig(state))
  useGetServiceConfigQuery({}, { skip: false })

  useEffect(() => {
    if (data) {
      const chatEntry = data.find((entry: any) => entry.service_descriptive_name === 'ChatNSR')
      const chatSettings = chatEntry?.chat_app_settings_vars || {}
      setChatNSRSettings(chatSettings)

      const cubeOptions = chatEntry?.lens_cube_options || []
      setLensCubeOptions(cubeOptions)
    }
  }, [data])

  return (
    <AppStateProvider>
      <Chat />
    </AppStateProvider>
  )
}

export default ChatStandalone
